module.exports = __webpack_public_path__ + "static/media/tip-one.69ee7c76.png";